import { useEffect } from 'react';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import { useFormikContext } from 'formik';

export interface DefaultOption {
  label: string
  value: number | string
}

interface RadioGroupsProps<U extends DefaultOption> {
  name: string;
  items: U[];
  value?: U['value'];
  onChange?: (value: string) => void
}

export const RadioGroups = <T extends {}, U extends DefaultOption>(props: RadioGroupsProps<U>) => {
  const { setFieldValue } = useFormikContext<T>();

  const changeValue = (value: U['value']) => {
    setFieldValue(
      props.name,
      value
    );
  };

  useEffect(() => {
    !props.value && changeValue(props.items[0].value);
  }, []);

  return (
    <FormControl>
      <RadioGroup
        name={props.name}
        value={props.value || props.items[0].value}
        onChange={(e, value) => {
          changeValue(value)
          props.onChange && props.onChange(value)
        }}
        row
      >
        {props.items.map(({ value, label }) => (
          <FormControlLabel
            key={value}
            value={value}
            control={<Radio color="primary" />}
            label={label}
          />
        ))}
      </RadioGroup>
    </FormControl>
  );
};

export default RadioGroups